import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {environment} from "../../environments/environment";
import {ThemeService} from "../_services/theme.service";
import {CommunitiesService} from "../_services/communities.service";

@Component({
    selector: 'app-invite-accept',
    templateUrl: './invite-accept.component.html',
    styleUrl: './invite-accept.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InviteAcceptComponent {
    companyImg: string = localStorage.getItem('communityLogo') || 'assets/explainLogoPlaceholder.png';
    companyName: string = localStorage.getItem('communityName') || 'Explain'
    community: any;
    inviteResponse: any;
    primaryColor: string = environment.primaryColor || '#1B9AAA';
    accentColor: string = environment.accentColor || '#c93457';

    constructor(private themeService: ThemeService,
                private authService: AuthService,
                private readonly snackBar: MatSnackBar,
                private route: ActivatedRoute,
                private readonly communitiesService: CommunitiesService) {

        localStorage.clear();

        this.route.params
            .subscribe(params => {
                if (params['token']) {
                    this.authService.getUserInvite(params['token']).subscribe(r => {
                        this.inviteResponse = r.data;
                        if (r.message == "Invite accepted") {
                            this.openSnackBar('You have been successfully added to this community', 'success')
                            this.authService.logout();
                        }
                        this.community = r.data.community;
                        this.companyImg = this.community?.logo || 'assets/explainLogoPlaceholder.png';
                        this.companyName = this.community?.name || 'Explain';
                        this.communitiesService.setCurrentDashboardCommunity(this.community);

                        if (this.community?.main_color_hex) {
                            this.primaryColor = r.main_color_hex
                        }
                        this.themeService.savePrimaryColor(this.primaryColor)

                        if (this.community?.accent_color_hex) {
                            this.accentColor = r.accent_color_hex;
                        }
                        this.themeService.saveAccentColor(this.accentColor)
                        if (this.community?.logo_background_color_hex) {
                            document.documentElement.style.setProperty(
                                `--logo-background`, r?.logo_background_color_hex
                            );
                        }
                    }, e => {
                        this.authService.logout();
                        this.openSnackBar(e, 'error')
                    })
                } else {
                    this.openSnackBar('No Invite Token Present', 'error')
                }
            }, error => {
                this.openSnackBar(error, 'error')
                console.error(error);
            });

    }


    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }

}
